import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useCurrentCompany } from '@bonusly/who-am-i';

import { CelebrationType } from '../types';

type Celebration = {
	date?: string;
	id: string;
	type: CelebrationType;
};

export interface Connection {
	celebrations_today: Celebration[];
	connection_strength: number;
	given: number;
	is_following?: boolean;
	received: number;
}

export const useConnectionData = (userId: string) => {
	const http = useHttpClient('v2');
	const company = useCurrentCompany();

	const {
		data: userData,
		isError,
		isLoading,
		status,
	} = useQuery(
		['connections-builder', userId],
		() =>
			http.get<{ result: Connection[] }>('/stronger_connections', {
				params: {
					company_id: company.id,
					user_ids: userId,
				},
			}),
		{
			select: ({ data: { result } }) => (result ? result[0] : undefined),
			staleTime: Number.POSITIVE_INFINITY,
		}
	);

	return {
		isError,
		isLoading,
		status,
		userData,
	};
};
